import { initASwap } from './aswap'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

// import { introLogoMorph } from "./lab/logo_morph";

const onLoadingComplete = () => {
  initASwap()
  setTimeout(() => {
    document.documentElement.classList.remove("index-loading")
  }, 600)
}

const boxHide = (el) => {
  TweenMax.to(el, .2, {alpha: 0, delay: .2})
  onLoadingComplete()
}

export const loadingSequence = () => {
  const box = document.getElementById("box-loading")
  if (box) {
    boxHide(box)
  } else {
    onLoadingComplete()
  }
  
}